import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { useApp } from "../../contexts/AppContext";
import { toast } from "sonner";
import { LogIn, Sparkles } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { setAdmin, checkAdmin } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) localStorage.setItem("admin_token", data.token);
      setAdmin({ id: data.id, email: data.email });
      await checkAdmin();
      toast.success("Bem-vindo!");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B1D3A] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 md:p-10 shadow-2xl">
        <div className="flex items-center gap-3 mb-6">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#FF6B6B] shadow-[0_6px_0_#C92A2A]">
            <Sparkles className="text-white" strokeWidth={2.5} />
          </span>
          <div>
            <h1 className="font-outfit text-2xl font-bold text-[#0B1D3A]">Back Office</h1>
            <p className="font-manrope text-sm text-[#0B1D3A]/60">NATALMÁTICO</p>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block font-manrope text-sm font-semibold text-[#0B1D3A] mb-1.5">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-login-email"
              className="w-full px-4 py-3 rounded-xl border-2 border-[#0B1D3A]/10 focus:border-[#005F73] outline-none font-manrope"
            />
          </div>
          <div>
            <label className="block font-manrope text-sm font-semibold text-[#0B1D3A] mb-1.5">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password"
              className="w-full px-4 py-3 rounded-xl border-2 border-[#0B1D3A]/10 focus:border-[#005F73] outline-none font-manrope"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-[#0B1D3A] text-white font-outfit font-bold py-3 hover:bg-[#1a2f5a] transition"
          >
            <LogIn size={18} /> Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
